function XCloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M19.546 17.9541C19.7573 18.1654 19.876 18.4521 19.876 18.7509C19.876 19.0498 19.7573 19.3365 19.546 19.5478C19.3346 19.7592 19.048 19.8779 18.7491 19.8779C18.4502 19.8779 18.1636 19.7592 17.9522 19.5478L12 13.5938L6.04596 19.5459C5.83461 19.7573 5.54797 19.876 5.24908 19.876C4.9502 19.876 4.66355 19.7573 4.45221 19.5459C4.24086 19.3346 4.12213 19.048 4.12213 18.7491C4.12213 18.4502 4.24086 18.1635 4.45221 17.9522L10.4063 12L4.45408 6.04595C4.24274 5.8346 4.12401 5.54796 4.12401 5.24907C4.12401 4.95019 4.24274 4.66354 4.45408 4.4522C4.66543 4.24085 4.95207 4.12212 5.25096 4.12212C5.54984 4.12212 5.83649 4.24085 6.04783 4.4522L12 10.4063L17.9541 4.45126C18.1654 4.23992 18.4521 4.12119 18.751 4.12119C19.0498 4.12119 19.3365 4.23992 19.5478 4.45126C19.7592 4.66261 19.8779 4.94925 19.8779 5.24814C19.8779 5.54702 19.7592 5.83367 19.5478 6.04501L13.5938 12L19.546 17.9541Z"
        fill="var(--purple-900)"
      />
    </svg>
  );
}

export default XCloseIcon;
